import { render, staticRenderFns } from "./TeamRegistration.vue?vue&type=template&id=2c7a4e65&"
import script from "./TeamRegistration.vue?vue&type=script&lang=js&"
export * from "./TeamRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports